export default __webpack_public_path__ + "static/media/mon_24.b540dbd8.png";